"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

var _templateObject;

var _default = (0, _client.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  query isTokenValid($token: String!) {\n    is_token_valid(token: $token) {\n      success\n      claimed\n      has_account\n      valid\n      email_address\n      customer_id\n      person_id\n    }\n  }\n"])));

exports["default"] = _default;